import React, { useState } from 'react';

const defaultValue = {
  transferencias: [],
  transferencia: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: '',
};

export const TransferenciaContext = React.createContext({});

export const TransferenciaProvider = (props) => {
  return (
    <TransferenciaContext.Provider
      value={{
        transferencias: useState(defaultValue.transferencias),
        transferencia: useState(defaultValue.transferencia),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </TransferenciaContext.Provider>
  );
};

export const TransferenciaConsumer = TransferenciaContext.Consumer;
